import { FontIcon, Persona, TooltipHost, useTheme } from '@fluentui/react';
import { FC, useMemo } from 'react';
import styled from 'styled-components';
import { IAgentReport, MediaTypes } from '../../models/reports.internal';
import { NoOverflowText } from '../../shared/styled-components';
import getTotalWorkItemCounts from '../../calculations/getTotalWorkItemCounts';
import { mediaIcons } from './AgentCard.helpers';

export const StyledPersona = styled(Persona)`
  .ms-Persona-details {
    padding: 0;
    padding-left: 0.5rem;
  }

  .ms-Persona-secondaryText {
    height: 21px;
  }
`;

export const ActivityDiv = styled.div`
  padding-left: 0.25rem;
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
`;

export const ActivityText = styled(NoOverflowText) <{ textStyle: string | undefined }>`
  flex-grow: 1;

  font-weight: ${p => p.textStyle === 'bold' && 500};
  font-style: ${p => p.textStyle === 'italic' && 'italic'};
  color: ${p => p.textStyle === 'grey' && p.theme.palette.neutralSecondary};
`;

//#region [1] Metrics
const RawMetric = styled.div<{ color?: string }>`
  font-size: 14px;
  background-color: ${p => p.theme.palette.neutralLight};
  color: ${p => p.color ? p.color : undefined};

  padding: 4px 6px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 52px;
  height: 26px;
`;

interface IMetricProps {
  iconName: string;
  count: number;
  tooltip: string;
  color?: string;
}

const Metric: FC<IMetricProps> = ({ iconName, count, tooltip, color }) => (
  <TooltipHost content={tooltip}>
    <RawMetric color={color}>
      <FontIcon iconName={iconName} style={{ marginTop: 1 }} />
      <span>{count}</span>
    </RawMetric>
  </TooltipHost>
);

const MetricContainer = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-gap: 4px;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(3, 1fr);
  flex-shrink: 0;
`;

export const TaskMetrics: FC<{ agent: IAgentReport }> = ({ agent }) => {
  const { palette } = useTheme();

  const totalHandledWorkItemsCount = useMemo(
    () => getTotalWorkItemCounts(agent.workItemsByMedia),
    [agent.workItemsByMedia],
  );

  return (
    <MetricContainer>
      <Metric iconName="Checkmark" count={totalHandledWorkItemsCount.handled} tooltip="Total handled task count" color={palette.greenDark} />
      <Metric iconName="Cancel" count={totalHandledWorkItemsCount.missed} tooltip="Total missed task count" color={palette.redDark} />
      {
        MediaTypes.map(mt => <Metric key={mt} iconName={mediaIcons[mt]} count={agent.workItemsByMedia[mt].handled} tooltip={`Handled ${mt} task count`} />)
      }
    </MetricContainer>
  );
};
//#endregion